import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent, AlertController } from '@ionic/angular';  // renamed from Content

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api/api.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { SiteStructure } from 'src/app/services/global/structure';
import { GeolocationWrapperService } from 'src/app/services/geolocation/geolocation.service';


@Component({
  selector: 'myquestionnaire',  // <<< NOTE manually changed from "app-myquestionnaire"
  templateUrl: './myquestionnaire.component.html',
  styleUrls: ['./myquestionnaire.component.scss'],
})
export class MyquestionnaireComponent implements OnInit, OnDestroy  {

  @ViewChild(IonContent) content: IonContent;   
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  @Input() pageName:string; //@Input('pageName') pageName;
  //@Output() outQuestionnaireResponses: EventEmitter<any> = new EventEmitter<any>();
  @Output() outComponentReady: EventEmitter<any> = new EventEmitter<any>();

  private consoleLog:boolean = false;
  // public isPageReady:boolean = false;
  public isNoRecordsFound:boolean = false;
  public items:any;
  public currentItem:any;
  public currentIndex:number;
  public currentAnswer:string;

  public answerValues:any = ["YES", "NO"];
  
  public showQuestionnaire:boolean = false;
  public isQuestionnaireCompleted:boolean = false;

  public QuestionnaireFormId:number = 0;
  public TriggeredByStructuredFormId = 0;
  public TriggeredByStructuredResponseId = 0;
  public FormQuestion:string = "";
  public AdditionalPrompt:string = "";
  public AdditionalResponseRequiredFlag:boolean = false;
  public UserResponseText:string = "";
  public EventId:number = 0;
  //public SelectedResponseList:string = null; // = [];

  constructor(
      private alertController: AlertController
    , public apiProvider: ApiService
    , public commonProvider: CommonService
    , public globalProvider: GlobalService
    , public translate: TranslateService
    , public zone: NgZone
    , public events: Events
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_myquestionnaire;
    if (this.consoleLog) console.log('myquestionnaire.ctor - LifeCycle');
    this.Initialize("ctor");
  }
  
  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() // ngAfterViewInit()
  {
    if (this.consoleLog) console.log('myquestionnaire.ngOnInit - ' + this.pageName + ' - LifeCycle');
    this.Initialize("ngOnInit");
    this.NotifyReady(); // notify listeners that this component is in a ready state
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    if (this.consoleLog) console.log('myquestionnaire.ngOnDestroy - ' + this.pageName + ' - LifeCycle');
  }

  // ----------------------------------------------------
  // --------------  INITIALIZE   -----------------------
  // ----------------------------------------------------
  public Initialize(context:string)
  {
    if (this.consoleLog) console.log('myquestionnaire.Initialize');
    this.InitializeModelStructure('Initialize');
  }

  public ResetInitialize()
  {
    if (this.consoleLog) console.log('MyQuestionnaire.ResetInitialize');
    this.InitializeModelStructure('ResetInitialize');
  }

  InitializeModelStructure(context:string)
  {
    if (this.consoleLog) console.log('ActionsCheckinPage.InitializeModelStructure: ' + context);
    
    this.isNoRecordsFound = false;
    this.items = [];
    this.currentItem = null;
    this.currentIndex = -1;
    this.currentAnswer = null;

    this.answerValues = ["YES", "NO"];
  
    this.showQuestionnaire = false;
    this.isQuestionnaireCompleted = false;

    this.QuestionnaireFormId = 0;
    this.FormQuestion = "Please answer the following";
    this.AdditionalPrompt = "Additional Information";
    this.AdditionalResponseRequiredFlag = false;
    this.UserResponseText = "";
    this.EventId = 0;
  //public SelectedResponseList:string = null; // = [];
  }
  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  // ----------------------------------------------------
  // --- EMIT EVENT TO PARENT PAGE                    ---
  // ----------------------------------------------------
  /*
  // let the parent page call to get the completed questionnaire when it is ready
  NotifyParentsOfSelection()
  {
    if (this.consoleLog) console.log("myquestionnaire.NotifyParentsOfSelection: " + this.SelectedResponseList);
    if ((this.SelectedResponseList) && (this.SelectedResponseList.length !== 0))
    {
      this.outQuestionnaireResponses.emit(this.SelectedResponseList);
    }
    else
    {
      this.outQuestionnaireResponses.emit(null);  // no selection made yet
    }
  }
  */

  NotifyReady()
  {
    // not really necessary but kept here just in case or as an example
    if (this.consoleLog) console.log("myquestionnaire.NotifyReady");
    this.outComponentReady.emit(true); 
  }


  // ----------------------------------------------------
  // --- RECEIVE FORM ID TO LOOK UP                    ---
  // ----------------------------------------------------
  SetQuestionnaireFormId(QuestionnaireFormId:number
                        , TriggeredByStructuredFormId
                        , TriggeredByStructuredResponseId
                        ):boolean
  {
    if (this.consoleLog) console.log('MyQuestionnaire.SetQuestionnaireFormId: ' + QuestionnaireFormId);
    this.QuestionnaireFormId = QuestionnaireFormId;
    this.TriggeredByStructuredFormId = TriggeredByStructuredFormId;
    this.TriggeredByStructuredResponseId = TriggeredByStructuredResponseId; 

    if (QuestionnaireFormId == 0) // don't use "===" here!
    { 
      // this is perfectly valid as not all form responses trigger a questionnaire...
      console.log('MyQuestionnaire.SetQuestionnaireFormId: ' + QuestionnaireFormId + " - no questionnaire lookup required")
      this.showQuestionnaire = false;
      return false; 
    }

    this.CallRequestForQuestionnaire();
    return true;
  }


  // ----------------------------------------------------
  // --------------- API FUNCTION CALLS       -----------
  // ----------------------------------------------------

  CallRequestForQuestionnaire()
  {
    if (this.consoleLog) console.log('MyQuestionnaire.CallRequestForQuestionnaire: ' + this.QuestionnaireFormId);

    this.apiProvider.RequestForQuestionnaire(this.QuestionnaireFormId)
    .then(data => { 
      this.zone.run(() => {
        this.PopulateFormFromApiResponse(data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        console.warn("error", errorMessage);
        alert("Unable to read Questionnaire " + this.QuestionnaireFormId);
      });
    });
  }

  public CallResponseToQuestionnaire
              ( EventId
              , ContextFeatureId:number     // e.g. 4 for "CHECKIN"
              , ContextName:string          // "MobileCheckinId", "MobileSupportId", "MobileReportId"
              , ContextId:string            // MobileCheckinId, etc.
              )
  {
    if (this.consoleLog) console.log('MyQuestionnaire.CallResponseToQuestionnaire');

    let ResponseIdListYes = this.GetResponseIdListYes();
    let ResponseIdListNo = this.GetResponseIdListNo();
    let qsResponses = this.GetResponsesAsQueryString();

    this.apiProvider.ResponseToQuestionnaire
      ( this.QuestionnaireFormId
      , ResponseIdListYes
      , ResponseIdListNo
      , this.TriggeredByStructuredFormId
      , this.TriggeredByStructuredResponseId
      , EventId 
      , ContextFeatureId
      , ContextName
      , ContextId
      , qsResponses
      , this.UserResponseText
      )
    .then(data => { 
      this.zone.run(() => {
        // notify owning page of success?
        if (this.consoleLog) console.log("MyQuestionnaire.CallResponseToQuestionnaire: SUCCESS");
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        // notify owning page of failure?
        console.warn("MyQuestionnaire.CallResponseToQuestionnaire: ERROR", errorMessage);
      });
    });
  }


  // ----------------------------------------------------
  // --------------- HANDLE API RESPONSE      -----------
  // ----------------------------------------------------

  PopulateFormFromApiResponse(apiResponse:any)
  {
    if (this.consoleLog) console.log("MyQuestionnaire.PopulateFormFromApiResponse", apiResponse);

    this.showQuestionnaire = true;
    
    //this.EventId = this.commonProvider.GetValue(apiResponse.Event.EventId, 0);
    //this.StructuredFormId = apiResponse.StructuredForm.StructuredFormId;
    //this.AllowUserResponseTextFlag = this.commonProvider.GetBoolean(apiResponse.StructuredForm.AllowUserResponseTextFlag, true);
    this.AdditionalResponseRequiredFlag = this.commonProvider.GetBoolean(apiResponse.StructuredForm.AdditionalResponseRequiredFlag, true);
    this.AdditionalPrompt = this.commonProvider.GetValue(apiResponse.StructuredForm.AdditionalPrompt, 'Additional Information');
    //this.UserResponseText = ""; // this is entered by user
    this.FormQuestion = this.commonProvider.GetValue(apiResponse.StructuredForm.MessageText,"Please answer the following");
    //this.FormTitle = this.commonProvider.GetValue(apiResponse.StructuredForm.MessageTitleText,"REPORT FORM");
    
    let ResponseButtonTypeCode = this.commonProvider.GetValue(apiResponse.StructuredForm.ResponseButtonTypeCode,"DROPDOWN");  // DROPDOWN
    let ResponseChoiceTypeCode = this.commonProvider.GetValue(apiResponse.StructuredForm.ResponseChoiceTypeCode,"SINGLE");  // SINGLE
    let ResponseChoiceCount = this.commonProvider.GetValue(apiResponse.StructuredForm.ResponseChoiceCount,0); // 5

    // get the values as arrays
    let arrayResponseId = this.commonProvider.GetArrayValues(apiResponse.StructuredForm.ResponseListStructuredResponseFormId,"|","");  // 588|589|590|591|592
    let arrayResponseText = this.commonProvider.GetArrayValues(apiResponse.StructuredForm.ResponseListResponseText,"|","");
    let arrayActiveFlag = this.commonProvider.GetArrayValues(apiResponse.StructuredForm.ResponseListActiveFlag,"|","");
    let arrayDisplaySequence = this.commonProvider.GetArrayValues(apiResponse.StructuredForm.ResponseListDisplaySequence,"|","");
    let arrayTriggerQuestionnaireFormId = this.commonProvider.GetArrayValues(apiResponse.StructuredForm.ResponseListTriggerQuestionnaireFormId,"|","");

    // Override ResponseChoiceCount with the actual array (since some may be disabled)
    if (arrayResponseText)
    {
      ResponseChoiceCount = arrayResponseText.length; // 2017-09-20
    }

    // No records found
    if (ResponseChoiceCount === 0)
    {
      this.isNoRecordsFound = true;
      this.items = []; 
    }
    else
    {
      // records found
      this.isNoRecordsFound = false;
      this.items = []; 
      //for (let i = 0; i < ResponseChoiceCount; i++) // for(let i in data)
      for (let i = ResponseChoiceCount-1; i >= 0; i--) // go backwards to preserve desired sort order
      { 
        let showItem:boolean = arrayActiveFlag[i]; 

        if (showItem)
        {
          this.items.unshift
          (
            { id: arrayResponseId[i]
            , name: arrayResponseText[i]
            , showItem: showItem
            , isAnswered: false
            , isAnswerYes: false
            , isAnswerNo: false
            , answerValue: ""
            }
          );
        }
      }

      this.SetCurrentItem(0);
    }

    if (this.consoleLog) console.log("MyQuestionnaire.PopulateFormFromApiResponse items", this.items);
  }

  SetCurrentItem(index:number)
  {
    if (this.consoleLog) console.log("MyQuestionnaire.SetCurrentItem item:" + index, this.items[index]);
    this.currentIndex = index;
    this.currentItem = this.items[index];
    this.currentAnswer = null;
    this.isQuestionnaireCompleted = false;
  }

  btnSelectedAnswer(answerValue:string, item:any)
  {
    console.log("MyQuestionnaire.btnSelectedAnswer: " + answerValue, item);
    this.SetCurrentItemAnswer(answerValue);
  }

  btnItemSelected(item:any, index:number)
  {
    this.SetCurrentItem(index);
  }

  SetCurrentItemAnswer(answerValue)
  {
    let answer:boolean = false;
    if (answerValue === "YES")
    {
      answer = true;
    }
    else if (answerValue === "NO")
    {
      answer = false;
    }
    else
    {
      console.log("MyQuestionnaire.toggleAnswer UNKNOWN - " + answerValue);
      return;
    }

    this.items[this.currentIndex].isAnswered = true;
    this.items[this.currentIndex].isAnswerYes = answer;
    this.items[this.currentIndex].isAnswerNo = !(answer);
    this.items[this.currentIndex].answerValue = answerValue;

    this.currentItem.isAnswered = true;
    this.currentItem.isAnswerYes = answer;
    this.currentItem.isAnswerNo = !(answer);
    this.currentItem.answerValue = answerValue;

    if (this.currentIndex >= this.items.length - 1) // technically the last record
    {
      this.isQuestionnaireCompleted = true;
      this.currentItem = null;
    }
    else
    {
      this.isQuestionnaireCompleted = false;
      this.currentIndex++; // go to next
      this.SetCurrentItem(this.currentIndex);
    }
  }

  GetIsQuestionnaireCompleted():boolean
  {
    return this.isQuestionnaireCompleted;
  }

  GetResponsesAsQueryString():string
  {
    let qsResponses:string = "";
    let itemLength:number = this.items.length; 
    for (let i = 0; i < itemLength; i++) 
    { 
      qsResponses = qsResponses + "&ResponseId=" 
                  + this.items[i].id 
                  + "|"  
                  + this.items[i].answerValue
                  ;
    }
    if (this.consoleLog) console.log("MyQuestionnaire.GetResponsesAsQueryString: " + qsResponses);
    return qsResponses;
  }

  GetResponseIdListYes():string
  {
    let responseIdListYes:string = "";
    let delimiter:string = "";
    let itemLength:number = this.items.length; 
    for (let i = 0; i < itemLength; i++) 
    { 
      if ((this.items[i].isAnswered) && (this.items[i].isAnswerYes))
      {
        responseIdListYes = responseIdListYes + delimiter + this.items[i].id;
        delimiter = "|";
      }
    }
    if (this.consoleLog) console.log("MyQuestionnaire.GetResponseIdListYes: " + responseIdListYes);
    return responseIdListYes;
  }

  GetResponseIdListNo():string
  {
    let responseIdListNo:string = "";
    let delimiter:string = "";
    let itemLength:number = this.items.length; 
    for (let i = 0; i < itemLength; i++) 
    { 
      if ((this.items[i].isAnswered) && (this.items[i].isAnswerNo))
      {
        responseIdListNo = responseIdListNo + delimiter + this.items[i].id;
        delimiter = "|";
      }
    }
    if (this.consoleLog) console.log("MyQuestionnaire.GetResponseIdListNo: " + responseIdListNo);
    return responseIdListNo;
  }
}
